import React from "react";
import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import Quienes from "./Quienes";
import Contacto from "./Contacto";
import Lavadora from "./Lavadora";
import Nevera from "./Nevera";
import IndustrialR from "./InudstrialR";
import AireAcondicionado from "./AireAcondicionado";
import Ayuda from "./Ayuda";
import Productos from "./Productos";
import GasInstallation from "./GasInstallation";
import Herramienta from "./Herramienta";
import ResultadosBusqueda from "./ResultadosBusqueda";
import Envios from "./Envios";
import Garantias from "./Garantias";
import CalculadoraTecnica from "./CalculadoraTecnica";

import AdminProductos from "./AdminProductos";
import LoginAdmin from "./LoginAdmin";
import RutaAdmin from "./RutaAdmin";
import AdminFeaturedProducts from "./AdminFeaturedProducts";
import AdminNewProducts from "./AdminNewProducts";
import AdminMenu from "./AdminMenu";
import AdminCarousel from "./AdminCarousel";
import AdminDocumentos from "./AdminDocumentos";

/* ============================================================
   PÁGINA 404
============================================================ */

const PaginaNoEncontrada = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f7fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          background: "#ffffff",
          border: "1px solid #e4e7ec",
          borderRadius: "14px",
          padding: "40px 30px",
          textAlign: "center",
          boxShadow: "0 6px 20px rgba(16, 24, 40, 0.06)",
        }}
      >
        <div
          style={{
            width: "65px",
            height: "65px",
            margin: "0 auto 20px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#eaf2ff",
            color: "#0d6efd",
            fontSize: "28px",
          }}
        >
          <i className="bi bi-exclamation-circle"></i>
        </div>

        <span
          style={{
            color: "#0d6efd",
            fontSize: "12px",
            fontWeight: "700",
            letterSpacing: "1px",
          }}
        >
          ERROR 404
        </span>

        <h1
          style={{
            margin: "8px 0 10px",
            color: "#243b64",
            fontSize: "27px",
            fontWeight: "700",
          }}
        >
          Página no encontrada
        </h1>

        <p
          style={{
            margin: "0 0 24px",
            color: "#667085",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          La página que estás buscando no existe o la dirección ingresada no es
          correcta.
        </p>

        <a
          href="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 18px",
            background: "#0d6efd",
            color: "#ffffff",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          <i className="bi bi-house-door-fill"></i>
          Volver al inicio
        </a>
      </div>
    </div>
  );
};

/* ============================================================
   ROUTER
============================================================ */

const router = createBrowserRouter([
  /* ==========================================================
     PÁGINA PRINCIPAL
  ========================================================== */

  {
    path: "/",
    element: <App />,
  },

  /* ==========================================================
     PÁGINAS PÚBLICAS
  ========================================================== */

  {
    path: "/quienes",
    element: <Quienes />,
  },

  {
    path: "/contacto",
    element: <Contacto />,
  },

  {
    path: "/lavadora",
    element: <Lavadora />,
  },

  {
    path: "/nevera",
    element: <Nevera />,
  },

  {
    path: "/industrialr",
    element: <IndustrialR />,
  },

  {
    path: "/aireacondicionado",
    element: <AireAcondicionado />,
  },

  {
    path: "/ayuda",
    element: <Ayuda />,
  },

  {
    path: "/productos",
    element: <Productos />,
  },

  {
    path: "/gas",
    element: <GasInstallation />,
  },

  {
    path: "/herramienta",
    element: <Herramienta />,
  },

  {
    path: "/resultados",
    element: <ResultadosBusqueda />,
  },

  {
    path: "/envios",
    element: <Envios />,
  },

  {
    path: "/garantias",
    element: <Garantias />,
  },

  {
    path: "/calculadora",
    element: <CalculadoraTecnica />,
  },

  /* ==========================================================
     LOGIN ADMINISTRADOR
  ========================================================== */

  {
    path: "/login",
    element: <LoginAdmin />,
  },

  /* ==========================================================
     MENÚ ADMINISTRADOR
  ========================================================== */

  {
    path: "/admin",
    element: (
      <RutaAdmin>
        <AdminMenu />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     ADMIN PRODUCTOS
  ========================================================== */

  {
    path: "/admin-productos",
    element: (
      <RutaAdmin>
        <AdminProductos />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     ADMIN DESTACADOS
  ========================================================== */

  {
    path: "/admin-destacados",
    element: (
      <RutaAdmin>
        <AdminFeaturedProducts />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     ADMIN NUEVOS
  ========================================================== */

  {
    path: "/admin-nuevos",
    element: (
      <RutaAdmin>
        <AdminNewProducts />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     ADMIN CAROUSEL
  ========================================================== */

  {
    path: "/admin-carousel",
    element: (
      <RutaAdmin>
        <AdminCarousel />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     ADMIN DOCUMENTOS PDF
  ========================================================== */

  {
    path: "/admin-documentos",
    element: (
      <RutaAdmin>
        <AdminDocumentos />
      </RutaAdmin>
    ),
  },

  /* ==========================================================
     404 - SIEMPRE DEBE IR AL FINAL
  ========================================================== */

  {
    path: "*",
    element: <PaginaNoEncontrada />,
  },
]);

export default router;
